<template>
  <div class="tabs d-flex flex-row align-center">
    <div
      v-for="tab in availableTabs"
      :key="tab.id"
      class="tab-wrapper"
      :data-state="gate === tab.id && 'active'"
    >
      <GwTooltipNew
        v-if="tab.tooltip"
        placement="contextmenu"
      >
        <template #tooltip>
          <div class="d-flex flex-column align-left pa-1 ga-1">
            <span>
              {{ $t('payment.crypto.crypto_disabled') }}
            </span>
            <span
              class="switch-to-yearly"
              @click="$emit('switch-to-yearly')"
            >
              {{ $t('payment.change_to_yearly_subscription') }}
            </span>
          </div>
        </template>
        <template #opener="{ listeners }">
          <div v-on="tab.disabled && listeners">
            <PaymentTabButton
              :tab="tab"
              :gate="gate"
              @update:gate="$emit('update:gate', $event)"
            />
          </div>
        </template>
      </GwTooltipNew>
      <PaymentTabButton
        v-else
        :tab="tab"
        :gate="gate"
        @update:gate="$emit('update:gate', $event)"
      />
    </div>
  </div>
</template>

<script>
import GwTooltipNew from '@/components/lib/GwTooltip/GwTooltipNew.vue'
import PaypalSvg from '@/assets/payment/paypal.svg'
import AlipaySvg from '@/assets/payment/alipay.svg'
import WechatPaySvg from '@/assets/payment/wechat-pay.svg'
import PaymentTabButton from './PaymentTabButton.vue'

export default {
  name: 'PaymentGateTabs',
  components: {
    GwTooltipNew,
    PaymentTabButton,
  },
  props: {
    gate: {
      type: String,
      required: true,
    },
    paypalEnabled: {
      type: Boolean,
      default: false,
    },
    cryptoPaymentEnabled: {
      type: Boolean,
      default: false,
    },
    alipayEnabled: {
      type: Boolean,
      default: false,
    },
    wechatPayEnabled: {
      type: Boolean,
      default: false,
    },
    selectedPlan: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['switch-to-yearly', 'update:gate'],
  computed: {
    availableTabs() {
      return [
        {
          id: 'card',
          icon: 'mdi-credit-card-fast',
          alwaysVisible: true,
        },
        {
          id: 'paypal',
          iconComponents: [PaypalSvg],
          visible: this.paypalEnabled,
        },
        {
          id: 'crypto',
          icon: 'mdi-bitcoin',
          visible: this.cryptoPaymentEnabled,
          tooltip: true,
          disabled: this.selectedPlan?.interval === 'MONTHLY',
        },
        {
          id: 'other',
          iconComponents:
            this.alipayEnabled && this.wechatPayEnabled
              ? [AlipaySvg, WechatPaySvg]
              : this.alipayEnabled
                ? [AlipaySvg]
                : [WechatPaySvg],
          visible: this.alipayEnabled || this.wechatPayEnabled,
        },
      ].filter(tab => tab.alwaysVisible || tab.visible)
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs {
  width: 40rem;
  max-width: calc(100vw - 2rem);
}

.tab-wrapper {
  position: relative;
  flex: 1;
}

.tab {
  padding: 1.25rem 0;
  text-transform: uppercase;
  justify-content: center;
  border-radius: 0.75rem 0.75rem 0 0;
  --surface-bg-hover: rgba(255, 255, 255, 0.025);
  --surface-bg: transparent;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    gap: 0;
    height: 40px;

    & > ::v-deep(.btn_icon) {
      font-size: 1.2rem;
      margin-top: -0.5rem;
      height: 1.75rem;
      padding: 0.25rem;
    }
  }

  &[data-state='active'] {
    --surface-bg-opacity: 1;
    --surface-bg-opacity-hover: 1;
    --surface-bg: rgba(255, 255, 255, 0.125);
    --surface-bg-hover: rgba(255, 255, 255, 0.125);
    &::after {
      background: transparent;
    }
  }

  &[data-state='disabled'] {
    pointer-events: none;
    --surface-bg-opacity: 0;
    --surface-bg-opacity-hover: 0;
    --text-clr: var(--clr-grey-1);
  }
}

.switch-to-yearly {
  cursor: pointer;
  color: var(--clr-primary);
  &:hover {
    text-decoration: underline;
  }
}
</style>
